var _style, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 71.6 71.1",
    style: {
      enableBackground: "new 0 0 71.6 71.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5C2881;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 35.8,
    cy: 35.5,
    r: 35.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.5,30.5c0.3-0.3,0.8-0.9,1.1-1.6c0.9-2.2,0.5-2.6,0.5-2.6c-0.6-1.2-1.8-2.9-3.4-4.5 c-1.6-1.6-3.3-2.9-4.5-3.4c0,0-2-0.6-3.5,0.9c0,0,0,0,0,0c0,0,0,0,0,0l0,0c-0.2,0.2-0.4,0.4-0.6,0.6L31.5,30.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53,46.3c-0.6-1.2-1.8-2.9-3.4-4.5c-1.6-1.6-3.3-2.9-4.5-3.4c0,0-0.4-0.4-2.6,0.5c-0.6,0.3-1.2,0.7-1.6,1.1 l10.6,10.6c0.2-0.2,0.4-0.4,0.6-0.6h0c0,0,0,0,0,0c0,0,0,0,0,0C53.6,48.3,53,46.3,53,46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.8,41.4c-0.3,0.4-0.9,0.6-1.5,0.6c-1.9,0-4.8-1.7-6-2.9c-1.6-1.6-4.1-6.2-2.3-7.5c0.1-0.1,0.2-0.1,0.3-0.2 L20,21.1c-1.6,2.4-1.5,4.2-1.5,4.2s-0.3,8.5,9.4,18.2c9.1,9.1,17.2,9.4,18.1,9.4c0,0,0.1,0,0.1,0s0,0,0,0c0.3,0,2-0.1,4.2-1.5 L40,41.1C39.9,41.2,39.8,41.3,39.8,41.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/Call.6359a9476000c2112ef4bfd088258dbe.svg";
export { ForwardRef as ReactComponent };